(function () {
  var STORAGE_PREFIX = "parans_splash_seen__";
  var MAIN_ROLES = ["blue_block", "pink_block", "character", "cat"];

  function num(el, name, fallback) {
    if (!(el instanceof HTMLElement)) return fallback;
    var raw = getComputedStyle(el).getPropertyValue(name).trim();
    if (!raw) return fallback;
    var v = parseFloat(raw);
    return isFinite(v) ? v : fallback;
  }

  function intAttr(el, name, fallback) {
    if (!(el instanceof HTMLElement)) return fallback;
    var raw = el.getAttribute(name);
    if (raw == null || raw === "") return fallback;
    var v = parseInt(raw, 10);
    return isFinite(v) ? v : fallback;
  }

  function storage(kind) {
    try {
      return kind === "local" ? window.localStorage : window.sessionStorage;
    } catch (e) {
      return null;
    }
  }

  /* 0628 用户:"会话级"= session cookie。所有标签页共享(整个浏览器只播一次,新开标签也不重播);
     不带 expires/max-age → 浏览器完全关闭即删除 → 重新开浏览器再访问才再播。
     不用 sessionStorage——那是"按标签页"的,新开标签就会重播,不符合"每次开浏览器一次"。 */
  function cookieKey(sectionId) {
    return ("parans_splash_seen__" + sectionId).replace(/[^a-zA-Z0-9_]/g, "_");
  }
  function cookieHas(name) {
    return document.cookie.indexOf(name + "=") >= 0;
  }
  function cookieSetSession(name) {
    try { document.cookie = name + "=1; path=/; SameSite=Lax"; } catch (e) {}
  }

  function shouldPlay(root) {
    var trigger = root.getAttribute("data-pps-trigger") || "always";
    var sectionId = root.getAttribute("data-pps-section-id") || "default";
    var key = STORAGE_PREFIX + sectionId;
    if (trigger === "once_session") {
      var ck = cookieKey(sectionId);
      if (cookieHas(ck)) return false;
      cookieSetSession(ck);
    } else if (trigger === "once_local") {
      var ls = storage("local");
      if (ls && ls.getItem(key)) return false;
      if (ls) ls.setItem(key, "1");
    }
    return true;
  }

  function fitStage(root) {
    var overlay = root.querySelector(".pps__overlay");
    var stage = root.querySelector("[data-pps-stage]");
    if (!overlay || !stage) return;
    var designW = num(root, "--pps-stage-w", 1440);
    var designH = num(root, "--pps-stage-h", 900);
    var rect = overlay.getBoundingClientRect();
    if (!rect.width || !designW) return;
    var fit;
    if (root.classList.contains("pps--inline")) {
      fit = Math.min(1, rect.width / designW);
    } else if (rect.width <= 749) {
      /* 移动端(≤749):横屏舞台直接按宽缩会很小。改为按"泼墨主体宽度"放大填满手机宽,
         主体约占舞台宽的 contentFrac(可用 --pps-mobile-content 调)。桌面分支不受影响。 */
      var contentFrac = num(root, "--pps-mobile-content", 0);
      if (!contentFrac) contentFrac = 0.46;
      fit = rect.width / (designW * contentFrac);
      /* 限高:主体约占舞台高的 0.74,留上下边距,避免溢出竖屏 */
      var hLimit = (rect.height * 0.92) / (designH * 0.74);
      fit = Math.min(fit, hLimit, 1.8);
    } else {
      var hCap = rect.height > 0 ? rect.height / designH : 1;
      fit = Math.min(1, rect.width / designW, hCap);
    }
    stage.style.setProperty("--pps-fit", String(fit));
  }

  function readLayerSpec(layer, totalDuration) {
    var spec = {
      el: layer,
      role: layer.getAttribute("data-role") || "accent",
      startX: num(layer, "--start-x", 0),
      startY: num(layer, "--start-y", 0),
      startScale: num(layer, "--start-scale", 0.1),
      midX: num(layer, "--mid-x", 0),
      midY: num(layer, "--mid-y", 0),
      midWPx: num(layer, "--mid-w-px", 0),
      midHPx: num(layer, "--mid-h-px", 0),
      finalX: num(layer, "--final-x", 0),
      finalY: num(layer, "--final-y", 0),
      finalW: num(layer, "--final-w", 200),
      finalH: num(layer, "--final-h", 200),
      tStart: num(layer, "--t-start", 0),
      tMid: num(layer, "--t-mid", 800),
      tEnd: num(layer, "--t-end", 1600),
      bouncePct: num(layer, "--bounce-pct", 8),
      rotation: num(layer, "--rotation", 0),
      floatAmp: num(layer, "--float-amp", 0),
      floatPeriod: num(layer, "--float-period", 2800),
      floatPhase: num(layer, "--float-phase", 0),
    };
    spec.tEnd = Math.min(spec.tEnd, totalDuration);
    spec.tMid = Math.min(spec.tMid, spec.tEnd);
    spec.tStart = Math.min(spec.tStart, spec.tMid);
    return spec;
  }

  function tr(x, y, rot, scale) {
    return (
      "translate3d(" +
      x +
      "px," +
      y +
      "px,0) rotate(" +
      rot +
      "deg) scale(" +
      scale +
      ")"
    );
  }

  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function sampleWaypoints(waypts, t, cache) {
    t = Math.max(0, Math.min(1, t));
    if (!waypts.length) return { o: t, x: 0, y: 0, s: 1, op: 1 };
    if (t <= waypts[0].o) return cloneWp(waypts[0]);
    var last = waypts[waypts.length - 1];
    if (t >= last.o) return cloneWp(last);

    var i = cache && cache.segIdx != null ? cache.segIdx : 1;
    if (i >= waypts.length) i = waypts.length - 1;
    if (t > waypts[i].o) {
      while (i < waypts.length - 1 && t > waypts[i].o) i += 1;
    } else {
      while (i > 1 && t <= waypts[i - 1].o) i -= 1;
    }
    if (cache) cache.segIdx = i;

    var A = waypts[i - 1];
    var B = waypts[i];
    var seg = B.o - A.o;
    var localT = seg > 1e-8 ? (t - A.o) / seg : 0;
    var pt = {
      o: t,
      x: lerp(A.x, B.x, localT),
      y: lerp(A.y, B.y, localT),
      s: lerp(A.s, B.s, localT),
    };
    if (A.op !== undefined || B.op !== undefined) {
      var ao = A.op !== undefined ? A.op : B.op;
      var bo = B.op !== undefined ? B.op : A.op;
      if (ao !== undefined && bo !== undefined) pt.op = lerp(ao, bo, localT);
      else if (bo !== undefined) pt.op = bo;
      else if (ao !== undefined) pt.op = ao;
    }
    return pt;
  }

  function cloneWp(p) {
    var o = { o: p.o, x: p.x, y: p.y, s: p.s };
    if (p.op !== undefined) o.op = p.op;
    return o;
  }

  function buildSparseWaypoints(spec, totalDuration, isMain, useMidFrame) {
    var T = Math.max(1, totalDuration);
    var startOffset = Math.max(0, Math.min(1, spec.tStart / T));
    var midOffset = Math.min(0.999, Math.max(startOffset + 0.001, spec.tMid / T));
    var endOffset = Math.min(1, spec.tEnd / T);
    var midScale = 1;
    if (useMidFrame) {
      var midScaleX = spec.midWPx / Math.max(1, spec.finalW);
      var midScaleY = spec.midHPx / Math.max(1, spec.finalH);
      midScale = (midScaleX + midScaleY) / 2;
    }

    var w = [{ o: 0, x: spec.startX, y: spec.startY, s: spec.startScale, op: isMain ? 1 : 0 }];

    if (startOffset > 0) {
      w.push({
        o: startOffset,
        x: spec.startX,
        y: spec.startY,
        s: spec.startScale,
        op: isMain ? 1 : 0,
      });
    }

    if (!isMain) {
      var fadeO = Math.min(0.999, (spec.tStart + 60) / T);
      if (fadeO > startOffset + 1e-6) {
        w.push({ o: fadeO, x: spec.startX, y: spec.startY, s: spec.startScale, op: 1 });
      }
    }

    if (useMidFrame) {
      w.push({ o: midOffset, x: spec.midX, y: spec.midY, s: midScale, op: 1 });
    }

    var lastO = w[w.length - 1].o;
    if (spec.bouncePct > 0) {
      var bounceDelta = Math.min(180, Math.max(40, (spec.tEnd - spec.tStart) * 0.15));
      var bounceO = Math.max(lastO + 0.002, (spec.tEnd - bounceDelta) / T);
      bounceO = Math.min(bounceO, endOffset - 0.002);
      if (bounceO > lastO + 1e-6) {
        w.push({
          o: bounceO,
          x: spec.finalX,
          y: spec.finalY,
          s: 1 + spec.bouncePct / 100,
          op: 1,
        });
        lastO = bounceO;
      }
    }

    w.push({ o: endOffset, x: spec.finalX, y: spec.finalY, s: 1, op: 1 });
    if (endOffset < 1 - 1e-5) {
      w.push({ o: 1, x: spec.finalX, y: spec.finalY, s: 1, op: 1 });
    }
    return w;
  }

  function readMotionFps(root) {
    var fps = intAttr(root, "data-pps-fps", 120);
    return fps === 60 ? 60 : 120;
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    } catch (e) {
      return false;
    }
  }

  function buildAnimationPath(spec, totalDuration) {
    var isMain = MAIN_ROLES.indexOf(spec.role) !== -1;
    var useMidFrame = isMain && (spec.midWPx > 0 || spec.midHPx > 0);
    var waypts = buildSparseWaypoints(spec, totalDuration, isMain, useMidFrame);
    return {
      waypts: waypts,
      isMain: isMain,
      rot: spec.rotation,
      spec: spec,
      segIdx: 1,
    };
  }

  function applyLayerFrame(path, t) {
    var p = sampleWaypoints(path.waypts, t, path);
    var el = path.spec.el;
    el.style.transform = tr(p.x, p.y, path.rot, p.s);
    if (p.op !== undefined) {
      el.style.opacity = String(p.op);
    } else if (path.isMain) {
      el.style.opacity = "1";
    }
  }

  function prepareLayersForMotion(paths) {
    for (var i = 0; i < paths.length; i++) {
      paths[i].segIdx = 1;
      var el = paths[i].spec.el;
      el.style.willChange = "transform, opacity";
      applyLayerFrame(paths[i], 0);
    }
  }

  function resetLayerStyles(root) {
    var layers = root.querySelectorAll("[data-pps-layer]");
    for (var i = 0; i < layers.length; i++) {
      layers[i].style.transform = "";
      layers[i].style.opacity = "";
      layers[i].style.willChange = "";
      var inner = layers[i].querySelector(".pps__layer-float");
      if (inner) inner.style.transform = "";
    }
  }

  function clearLayerMotionHints(paths) {
    for (var i = 0; i < paths.length; i++) {
      paths[i].spec.el.style.willChange = "";
    }
  }

  function waypointsToKeyframes(waypts, rot, isMain) {
    var frames = [];
    var last = waypts.length - 1;
    for (var i = 0; i < waypts.length; i++) {
      var p = waypts[i];
      var f = { offset: p.o, transform: tr(p.x, p.y, rot, p.s) };
      if (i < last) f.easing = "linear";
      if (!isMain && p.op !== undefined) f.opacity = p.op;
      frames.push(f);
    }
    return frames;
  }

  function buildKeyframes(spec, totalDuration) {
    var path = buildAnimationPath(spec, totalDuration);
    var frames = waypointsToKeyframes(path.waypts, path.rot, path.isMain);
    var prev = -1;
    for (var i = 0; i < frames.length; i++) {
      if (frames[i].offset <= prev) frames[i].offset = Math.min(1, prev + 0.0001);
      prev = frames[i].offset;
    }
    return frames;
  }

  function cancelSplashMotion(root) {
    if (root.__ppsSplashRaf) {
      cancelAnimationFrame(root.__ppsSplashRaf);
      root.__ppsSplashRaf = null;
    }
    var mainAnims = root.__ppsMainAnims || [];
    for (var i = 0; i < mainAnims.length; i++) {
      try {
        mainAnims[i].cancel();
      } catch (e) {}
    }
    root.__ppsMainAnims = [];
    if (root.__ppsPaths) clearLayerMotionHints(root.__ppsPaths);
  }

  function finishSplashEnter(root, floatSpecs) {
    var floatAnims = root.__ppsFloatAnims || [];
    root.classList.remove("pps--animating");
    /* 移动端被移出的「Customize Now」按钮:等其它元素入场动画全部播完(此处)才淡入,最后出现 */
    var movedBtn = root.querySelector('.pps__layer--button[data-pps-moved]');
    if (movedBtn) movedBtn.style.opacity = "1";
    if (root.__ppsPaths) clearLayerMotionHints(root.__ppsPaths);
    if (floatSpecs.length) root.classList.add("pps--floating");
    for (var i = 0; i < floatSpecs.length; i++) {
      var fa = startFloat(floatSpecs[i]);
      if (fa) floatAnims.push(fa);
    }
    root.__ppsFloatAnims = floatAnims;

    /* 2026-06 用户(重要):开屏动画**不自动消失**——播完后停留在屏幕上,
       只有用户点「Skip 跳过」或点中间的图片/CTA 按钮才会关闭(leave 由 bindInteractions 绑定)。
       所以这里**不**做任何自动 leave。 */
  }

  function startFloat(spec) {
    if (!spec.floatAmp || !spec.el) return null;
    var inner = spec.el.querySelector(".pps__layer-float");
    if (!inner) return null;
    if (typeof inner.animate !== "function") return null;
    try {
      inner.style.transform = "";
      var amp = spec.floatAmp;
      var anim = inner.animate(
        [
          { transform: "translate3d(0, 0, 0)", easing: "linear" },
          { transform: "translate3d(0, " + (-amp * 0.55) + "px, 0)", easing: "linear" },
          { transform: "translate3d(0, " + -amp + "px, 0)", easing: "linear" },
          { transform: "translate3d(0, " + (-amp * 0.55) + "px, 0)", easing: "linear" },
          { transform: "translate3d(0, 0, 0)" },
        ],
        {
          duration: spec.floatPeriod,
          iterations: Infinity,
          easing: "linear",
          delay: -Math.abs(spec.floatPhase % spec.floatPeriod),
        }
      );
      return anim;
    } catch (e) {
      return null;
    }
  }

  function playSplashWithWaapi(root, paths, totalDuration, floatSpecs) {
    var floatAnims = [];
    var mainAnims = [];
    for (var i = 0; i < paths.length; i++) {
      var path = paths[i];
      var spec = path.spec;
      var layer = spec.el;
      if (typeof layer.animate !== "function") {
        applyLayerFrame(path, 1);
        if (spec.floatAmp) {
          var fa0 = startFloat(spec);
          if (fa0) floatAnims.push(fa0);
        }
        continue;
      }
      var frames = buildKeyframes(spec, totalDuration);
      try {
        var anim = layer.animate(frames, {
          duration: totalDuration,
          fill: "forwards",
          easing: "linear",
        });
        if (anim) mainAnims.push(anim);
      } catch (e) {
        applyLayerFrame(path, 1);
      }
    }
    root.__ppsFloatAnims = floatAnims;
    root.__ppsMainAnims = mainAnims;
    var floatTimer = setTimeout(function () {
      finishSplashEnter(root, floatSpecs);
    }, totalDuration);
    root.__ppsTimers = root.__ppsTimers || [];
    root.__ppsTimers.push(floatTimer);
  }

  function playSplash(root) {
    var stage = root.querySelector("[data-pps-stage]");
    if (!stage) return;
    var layers = Array.prototype.slice.call(root.querySelectorAll("[data-pps-layer]"));
    if (!layers.length) {
      root.classList.add("is-ready");
      return;
    }
    var totalDuration = Math.max(200, intAttr(root, "data-pps-duration", 3000));

    cancelSplashMotion(root);
    root.classList.add("is-ready");
    root.classList.add("pps--animating");

    var paths = [];
    var floatSpecs = [];
    for (var i = 0; i < layers.length; i++) {
      var spec = readLayerSpec(layers[i], totalDuration);
      if (spec.floatAmp) floatSpecs.push(spec);
      paths.push(buildAnimationPath(spec, totalDuration));
    }
    root.__ppsPaths = paths;
    root.__ppsFloatAnims = [];
    prepareLayersForMotion(paths);

    if (prefersReducedMotion()) {
      for (var j = 0; j < paths.length; j++) applyLayerFrame(paths[j], 1);
      finishSplashEnter(root, floatSpecs);
      return;
    }

    if (typeof requestAnimationFrame !== "function") {
      playSplashWithWaapi(root, paths, totalDuration, floatSpecs);
      return;
    }

    var t0 =
      typeof performance !== "undefined" && typeof performance.now === "function"
        ? performance.now()
        : Date.now();

    function frame(now) {
      if (root.__ppsLeaving) {
        cancelSplashMotion(root);
        return;
      }
      var elapsed = now - t0;
      var t = elapsed / totalDuration;
      if (t > 1) t = 1;
      for (var k = 0; k < paths.length; k++) applyLayerFrame(paths[k], t);
      if (t < 1) {
        root.__ppsSplashRaf = requestAnimationFrame(frame);
      } else {
        root.__ppsSplashRaf = null;
        var floatTimer = setTimeout(function () {
          finishSplashEnter(root, floatSpecs);
        }, 0);
        root.__ppsTimers = root.__ppsTimers || [];
        root.__ppsTimers.push(floatTimer);
      }
    }

    root.__ppsSplashRaf = requestAnimationFrame(frame);
  }

  function leave(root) {
    if (root.__ppsLeaving) return;
    root.__ppsLeaving = true;
    cancelSplashMotion(root);
    root.classList.remove("pps--animating", "pps--floating");
    root.classList.add("pps--leaving");
    var ms = 360;
    var timer = setTimeout(function () {
      if (root.classList.contains("pps--overlay")) {
        root.classList.add("pps--hidden");
      }
      // 停止悬浮
      var fa = root.__ppsFloatAnims || [];
      for (var i = 0; i < fa.length; i++) {
        try {
          fa[i].cancel();
        } catch (e) {}
      }
      var timers = root.__ppsTimers || [];
      for (var j = 0; j < timers.length; j++) clearTimeout(timers[j]);
    }, ms);
    root.__ppsTimers = root.__ppsTimers || [];
    root.__ppsTimers.push(timer);
  }

  function bindInteractions(root) {
    var skip = root.querySelector("[data-pps-skip]");
    if (skip) {
      skip.addEventListener("click", function (e) {
        e.preventDefault();
        leave(root);
      });
    }
    var buttons = root.querySelectorAll('[data-pps-layer][data-role="button"]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener("click", function (e) {
        var el = e.currentTarget;
        if (!(el instanceof HTMLAnchorElement) || !el.getAttribute("href")) {
          e.preventDefault();
        }
        leave(root);
      });
    }
    if (!root.__ppsKeydown) {
      root.__ppsKeydown = function (e) {
        if (root.classList.contains("pps--hidden")) return;
        if (!root.classList.contains("pps--overlay")) return;
        if (e.key === "Escape") leave(root);
      };
      document.addEventListener("keydown", root.__ppsKeydown);
    }
    if (!root.__ppsResize) {
      root.__ppsResize = function () {
        if (root.__ppsResizeRaf) cancelAnimationFrame(root.__ppsResizeRaf);
        root.__ppsResizeRaf = requestAnimationFrame(function () {
          root.__ppsResizeRaf = null;
          fitStage(root);
        });
      };
      window.addEventListener("resize", root.__ppsResize);
    }
  }

  function setup(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.__ppsInited) return;
    root.__ppsInited = true;

    /* 移动端(≤749):把「Customize Now」按钮移出被 scale 缩放的 stage,放进未缩放的 overlay,
       这样按钮按真实尺寸显示在屏幕下方(在泼墨动画的下面),不会被 stage 的 scale 缩小。桌面不动。 */
    if (window.innerWidth <= 749) {
      var ppsOverlay = root.querySelector(".pps__overlay");
      var ppsBtn = root.querySelector('[data-pps-layer][data-role="button"]');
      if (ppsOverlay && ppsBtn && ppsBtn.parentElement !== ppsOverlay) {
        ppsOverlay.appendChild(ppsBtn);
        ppsBtn.setAttribute("data-pps-moved", "1");
        /* 去掉 data-pps-layer:不让入场循环控制它(static 按钮会被循环直接设为可见)。
           改为自己控制:初始隐藏,2.6 秒后淡入(其它元素都飞完了,按钮最后出现);点击=进入站点。 */
        ppsBtn.removeAttribute("data-pps-layer");
        ppsBtn.style.opacity = "0";
        ppsBtn.style.transition = "opacity 0.45s ease";
        ppsBtn.addEventListener("click", function () { leave(root); });
        /* 淡入时机由 finishSplashEnter()(其它元素入场动画播完时)触发;此处仅做兜底,防意外永不出现 */
        setTimeout(function () { if (ppsBtn.style.opacity !== "1") ppsBtn.style.opacity = "1"; }, 4500);
      }
    }

    if (!shouldPlay(root)) {
      if (root.classList.contains("pps--overlay")) {
        root.classList.add("pps--hidden");
      } else {
        // inline 模式下，跳过仍展示终态画面
        root.classList.add("is-ready");
        var layers = root.querySelectorAll("[data-pps-layer]");
        for (var i = 0; i < layers.length; i++) {
          var spec = readLayerSpec(layers[i], 1);
          layers[i].style.transform = tr(spec.finalX, spec.finalY, spec.rotation, 1);
          layers[i].style.opacity = "1";
          if (spec.floatAmp) startFloat(spec);
        }
      }
      bindInteractions(root);
      fitStage(root);
      return;
    }

    bindInteractions(root);
    fitStage(root);

    // 等待图片解码后再播放，避免首帧空白
    var imgs = root.querySelectorAll("img");
    var pending = imgs.length;
    var TIMEOUT = 1200;
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      requestAnimationFrame(function () {
        playSplash(root);
      });
    }
    if (!pending) {
      go();
    } else {
      var done = function () {
        pending -= 1;
        if (pending <= 0) go();
      };
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        if (img.complete) {
          done();
        } else {
          img.addEventListener("load", done, { once: true });
          img.addEventListener("error", done, { once: true });
        }
      }
      setTimeout(go, TIMEOUT);
    }

  }

  function reset(root) {
    if (!(root instanceof HTMLElement)) return;
    root.__ppsInited = false;
    root.__ppsLeaving = false;
    root.classList.remove("pps--hidden", "pps--leaving", "is-ready", "pps--animating", "pps--floating");
    resetLayerStyles(root);
    var timers = root.__ppsTimers || [];
    for (var i = 0; i < timers.length; i++) clearTimeout(timers[i]);
    root.__ppsTimers = [];
    cancelSplashMotion(root);
    if (root.__ppsResizeRaf) {
      cancelAnimationFrame(root.__ppsResizeRaf);
      root.__ppsResizeRaf = null;
    }
    var anims = (root.__ppsMainAnims || []).concat(root.__ppsFloatAnims || []);
    for (var j = 0; j < anims.length; j++) {
      try {
        anims[j].cancel();
      } catch (e) {}
    }
    root.__ppsMainAnims = [];
    root.__ppsFloatAnims = [];
    if (root.__ppsKeydown) {
      document.removeEventListener("keydown", root.__ppsKeydown);
      root.__ppsKeydown = null;
    }
    if (root.__ppsResize) {
      window.removeEventListener("resize", root.__ppsResize);
      root.__ppsResize = null;
    }
  }

  function initAll(scope) {
    var root = scope instanceof HTMLElement ? scope : document;
    root.querySelectorAll("[data-pps]").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Shopify 主题编辑器：section 重新加载
  document.addEventListener("shopify:section:load", function (e) {
    if (!(e.target instanceof HTMLElement)) return;
    var nodes = e.target.querySelectorAll("[data-pps]");
    for (var i = 0; i < nodes.length; i++) reset(nodes[i]);
    initAll(e.target);
  });

  document.addEventListener("shopify:section:select", function (e) {
    if (!(e.target instanceof HTMLElement)) return;
    var nodes = e.target.querySelectorAll("[data-pps]");
    for (var i = 0; i < nodes.length; i++) {
      reset(nodes[i]);
      setup(nodes[i]);
    }
  });
})();
